module.exports = __webpack_public_path__ + "img/widows_installer_32_or_64.9f1d5a51.png";